import { useEffect } from 'react';

/**
 * Hook para adicionar comportamento padrão de fechamento de modais:
 * - ESC key para fechar
 * - Evita propagação de eventos do modal
 */
export const useModalClose = (isOpen: boolean, onClose: () => void) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);
};
